import { render, staticRenderFns } from "./promotion.vue?vue&type=template&id=fa9b342a&"
import script from "./promotion.vue?vue&type=script&lang=js&"
export * from "./promotion.vue?vue&type=script&lang=js&"
import style0 from "./promotion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports